import { JoonUIColor } from "@joonapp/web-shared"

export const isValidUrl = (urlString: string) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}

export const renderMessageWithLinks = (
  text: string,
  isMyMessage: boolean = false
) => {
  const words = text.split(" ")
  return words.map((word, index) => {
    if (isValidUrl(word)) {
      return (
        <>
          <a
            href={word.startsWith("http") ? word : `https://${word}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: isMyMessage
                ? JoonUIColor.text.inverted
                : JoonUIColor.text.primaryAccent,
              textDecoration: "underline",
            }}
          >
            {word}
          </a>
          {index < words.length - 1 ? " " : ""}
        </>
      )
    }
    return index < words.length - 1 ? `${word} ` : word
  })
}
